import { Camera, Image, FileText } from 'lucide-react';
import { isIOSDevice } from '../utils/platform';

export default function PhotoPickerModal({ show, onClose, onSelect }) {
  if (!show) return null;

  // On iOS, the native file picker already offers Camera, Photo Library, and Browse.
  // Skip our custom modal to avoid a redundant double-picker and WKWebView crash.
  if (isIOSDevice) {
    // Trigger 'library' which just calls fileRef.click() without capture —
    // iOS will show its native picker with all options including camera.
    onSelect('library');
    return null;
  }

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={panelStyle} onClick={(e) => e.stopPropagation()}>
        {/* Drag handle */}
        <div style={handleStyle} />

        {/* Options */}
        <button style={optionBtnStyle} onClick={() => onSelect('camera')}>
          <Camera size={20} color="var(--text-primary)" />
          <span>Take Photo</span>
        </button>

        <button style={optionBtnStyle} onClick={() => onSelect('library')}>
          <Image size={20} color="var(--text-primary)" />
          <span>Choose from Library</span>
        </button>

        <button style={optionBtnStyle} onClick={() => onSelect('file')}>
          <FileText size={20} color="var(--text-primary)" />
          <span>Browse Files</span>
        </button>

        {/* Cancel */}
        <button style={cancelBtnStyle} onClick={onClose}>
          Cancel
        </button>
      </div>

      <style>{`
        @keyframes photoPickerSlideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  zIndex: 300,
  padding: 0,
};

const panelStyle = {
  background: 'var(--bg-card)',
  borderRadius: '16px 16px 0 0',
  padding: '12px 20px',
  paddingBottom: 'max(20px, env(safe-area-inset-bottom))',
  width: '100%',
  maxWidth: 480,
  border: '1px solid var(--border)',
  borderBottom: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  animation: 'photoPickerSlideUp 0.25s ease-out',
};

const handleStyle = {
  width: 40,
  height: 4,
  borderRadius: 2,
  background: 'var(--border)',
  margin: '0 auto 8px',
};

const optionBtnStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '14px 16px',
  borderRadius: 'var(--radius-sm)',
  border: '1.5px solid var(--border)',
  background: 'transparent',
  cursor: 'pointer',
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: 'var(--text-primary)',
};

const cancelBtnStyle = {
  width: '100%',
  padding: '12px 16px',
  borderRadius: 'var(--radius-sm)',
  border: '1px solid var(--border)',
  background: 'transparent',
  color: 'var(--text-secondary)',
  fontWeight: 600,
  fontSize: '0.875rem',
  cursor: 'pointer',
  marginTop: 2,
};
